export enum riskTypeEnum {
  STANDARD = "Standard"
}

export enum CustomerRiskStatusEnum {
  UNKNOWN = "Unknown",
  HIGH = "High",
  STANDARD = "Standard"
}

export enum AdverseMediaRisk {
  HIGH = "High",
  MEDIUM = "Medium",
  LOW = "Low"
}
